export default __webpack_public_path__ + "static/media/kms-image.2a0723da.png";